import React from "react";
import { inject, observer } from "mobx-react";
import { observable } from "mobx";
import { IManagementStore } from "Stores/Management/types";
import ApplicationPermissionsContent from "./ApplicationPermissionsContent";
import { Values } from "@src/Tools/Values";
import { IValuesStore } from "@src/Stores/Values/types";

interface IProps {
  management?: IManagementStore;
  values?: IValuesStore;
}

@inject("management", "values")
@observer
class ApplicationPermissions extends React.Component<IProps> {
  @observable isLoading: boolean = true;
  
  async componentDidMount() {    
    try {
      await Promise.all([
        await this.props.management.getApplicationPermissions(),
        await this.props.management.getActiveOrganisations(),
        await this.props.management.getActivePositions(),
        await this.props.management.getActivePositionTeams(),
        await this.props.values.GetKnownApplicationUrls(),
      ]);
      this.isLoading = false;
      document.title = Values.getLocalizationValue("applicationPermissions");
    } catch (error) {
      console.error(error);
    }
  }
  render() {
    return <div>{this.isLoading ? <div /> : <ApplicationPermissionsContent />}</div>;
  }
}

export default ApplicationPermissions;
